/**
 * Admin 대시보드·사이트·업로드. 라우트 admin.php 와 동기화.
 * data-controller="AdminController", data-action="dashboard" | "components" | "siteIndex" | "uploadImage" | "uploadAttachment"
 * - components: DatePicker, QuillEditor 래퍼 사용 (SlimSelect는 initAdminSelects에서 SelectWrapper로 처리)
 */
import { Logger } from "../../utils/Logger";
import { DatePicker } from "../../components/DatePicker";
import { QuillEditor } from "../../components/QuillEditor";

function noop(action: string): void {
    Logger.debug(`AdminController.${action} (no-op)`);
}

export const AdminController = {
    dashboard(): void {
        noop("dashboard");
    },
    components(): void {
        const datetimeWrap = document.querySelector<HTMLElement>("[data-datetime-wrap]");
        const datetimeInput = document.getElementById("demo-datetime");
        if (datetimeWrap && datetimeInput) {
            datetimeWrap.addEventListener("click", () => (datetimeInput as HTMLElement).focus());
            new DatePicker("demo-datetime", {
                enableTime: true,
                dateFormat: "Y-m-d H:i",
                time24hr: true,
            }).init();
        }

        const timeWrap = document.querySelector<HTMLElement>("[data-time-wrap]");
        const timeInput = document.getElementById("demo-time");
        if (timeWrap && timeInput) {
            timeWrap.addEventListener("click", () => (timeInput as HTMLElement).focus());
            new DatePicker("demo-time", {
                enableTime: true,
                noCalendar: true,
                dateFormat: "H:i",
                time24hr: true,
            }).init();
        }

        const editorWrap = document.getElementById("demo-editor-wrap");
        if (editorWrap) {
            new QuillEditor(editorWrap, {
                placeholder: "내용을 입력하세요.",
                toolbar: [
                    ["bold", "italic"],
                    [{ list: "ordered" }, { list: "bullet" }],
                    ["link"],
                ],
            }).init();
        }
    },
    siteIndex(): void {
        noop("siteIndex");
    },
    uploadImage(): void {
        noop("uploadImage");
    },
    uploadAttachment(): void {
        noop("uploadAttachment");
    },
};
